import classnames from 'classnames';
import React, { useRef } from 'react';
import { isNone } from '../_util/defineType';
import Elevation from '../elevation';
import BasicLayout from './basic-layout';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { useSize } from 'ahooks';

const CreateLayout = props => {
  const {
    showShadow = true,
    alert,
    banner,
    rightPart,
    rightStickyTop,
    children,
    title,
    subtitle,
    extra,
    initing,
    whatIsUrl,
    howToUrl,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout-create");
  const hasAlert = !isNone(alert);
  const hasBanner = !isNone(banner);
  const hasRightPart = !isNone(rightPart);
  const ref = useRef(null);
  // const size = useSize(ref);
  return /*#__PURE__*/_jsxs(BasicLayout, {
    ref: ref,
    title: title,
    subtitle: subtitle,
    extra: extra,
    initing: initing,
    whatIsUrl: whatIsUrl,
    howToUrl: howToUrl,
    className: classnames(baseClassName, className),
    style: style,
    children: [hasAlert && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--alert"),
      children: alert
    }), banner, /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--main"),
      children: [/*#__PURE__*/_jsx(Elevation, {
        type: 3,
        className: "left",
        borderRadius: {
          topLeft: hasBanner ? 0 : undefined,
          topRight: hasRightPart ? 0 : undefined,
          bottomRight: hasRightPart ? 0 : undefined
        },
        shadow: showShadow,
        children: children
      }), !!rightPart && /*#__PURE__*/_jsx(Elevation, {
        type: 5,
        className: "right",
        borderRadius: {
          topLeft: 0,
          topRight: hasBanner ? 0 : undefined,
          bottomLeft: 0
        },
        shadow: showShadow,
        children: /*#__PURE__*/_jsx("div", {
          style: rightStickyTop ? {
            top: rightStickyTop
          } : undefined,
          children: rightPart
        })
      })]
    })]
  });
};
export default CreateLayout;